<template>
  <div>
    <v-layout wrap justify-center align-center>
        <v-flex md7 sm7 xs12>
            <dialogos-app :dialogos="dialogos" tucan="0" 
                          @update:currentText="currentText = $event"
            ></dialogos-app>
        </v-flex>
    </v-layout>
    <v-layout wrap row justify-center align-center text-xs-center mt-3 class="cont_page" :class="{'noclick':noclick}">
      <v-flex xs12>
        <div >
        <p  @click="modal1=true" class="titulo conten_img animated bounceIn dura-1"></p>
        </div>
      </v-flex>
    <v-layout wrap row justify-center align-center text-xs-center mt-3 class="">
      <div class="draggable_contenido">
        <strong><p class="title-table">Com som de U.</p></strong>
          <draggable 
                    class=" elemento_amarillo" 
                    v-model="VectorUno" 
                    :options="{group:{ name:'parceros', pull:true, put:(VectorUno.length> 4?false:true)}}"
                    @start="drag=true" 
                    @change="validando(VectorUno,Correctoz,0,bien1)">
                    <div class="grag_superior_contenido" v-for="(element, index) in VectorUno" :key="element.id" 
                         :class="{'bien':bien1[index], 'mal':!bien1[index]}">
                      <span class="elementointerno">{{element.palabra}}</span>
                    </div>
          </draggable>
      </div> 
      <div class="draggable_contenidos">
        <strong><p class="title-table">Com som de O.​</p></strong>
        <draggable class=" elemento_amarillo" 
                  v-model="VectorDos"
                  @start="drag=true"
                  :options="{group:{ name:'parceros', pull:true, put:(VectorDos.length> 4?false:true)}}"
                  @change="validando(VectorDos,Correctos,1,bien2)">
                  <div class="grag_superior_contenido" v-for="(element,index) in VectorDos" :key="element.id">
                    <div class="elementointerno" :class="{'bien':bien2[index], 'mal':!bien2[index]}">
                      <span class="elementointerno">{{element.palabra}}</span>
                    </div>
                  </div>
        </draggable>
      </div>            
      <v-flex xs12 mt-3 class="btn-drag">
        <v-card flat tile color="transparent">  
          <v-card-actions class="cont-btn-nextprev slidebtn" >
            <div class="btn-slide-prev hvr" fab small @click="prev">
              <v-icon color="#5A8B34" size="40">navigate_before</v-icon>
            </div>
            <div>
              <v-window v-model="onboarding">
                <div class="letraa">
                  <draggable  class="grag_inferior_interno" 
                              v-model="vectoroObj" 
                              group="parceros" 
                              @start="drag=true"
                  >
                    <v-window-item  
                                    class=" btn-blue-dark btn-drag hvr grag_inferior_interno" 
                                    v-for="(element, index) in vectoroObj" 
                                    :key="index" 
                    >
                        <span v-html="element.palabra"></span>
                    </v-window-item>
                  </draggable>
                </div>
              </v-window> 
            </div>                
            <div class="btn-slide-next hvr" fab small @click="next">
              <v-icon color="#5A8B34" size="40">navigate_next</v-icon>
            </div>
          </v-card-actions>
        </v-card>            
      </v-flex>
      </v-layout>
      <modalResultadoApp v-model="modal" 
                         :nameResult="modalResult"
                         @bienAvanzar="avanzar"
                         @malAvanzar="reiniciar"
      ></modalResultadoApp>  
    </v-layout>
     <audio-player ref="audioPlayer" :autoplay="false" 
                  :audios="['slide10/Guru','slide10/Sul','slide10/Farol','slide10/Calma','slide10/Prato','slide10/Avo','slide10/Do','slide10/Forro','slide10/Metro']"
    ></audio-player>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import modalResultadoApp from '@/components/modal-resultado.vue';
import draggable from 'vuedraggable'
export default {
    components: {
            draggable,
            modalResultadoApp
        },
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Coloque as palavras na coluna correta, de acordo com a pronúncia.​'
      ],
        modal1: true,
        modal: false,
        onboarding: 0,
        modalResult: '',
        vector: [
          'sul', 
          'guru', 
          'calma', 
          'farol', 
          'avô', 
          'prato', 
          'forró', 
          'metrô',
          'dó', 
          ],
          vectoroObj: [  
              {palabra:'guru', audio: 0}, 
              {palabra:'sul', audio: 1}, 
              {palabra:'farol', audio: 2}, 
              {palabra:'calma', audio: 3}, 
              {palabra:'prato', audio: 4}, 
              {palabra:'avô', audio: 5}, 
              {palabra:'dó', audio: 6}, 
              {palabra:'forró', audio: 7}, 
              {palabra:'metrô', audio: 8},
          ],
          VectorUno:[],
          VectorDos:[],
          Correctoz:[
              'guru',
              'calma',  
              'farol', 
              'prato', 
              'sul', 
          ],
          Correctos:[       
              'avô', 
              'dó', 
              'forró', 
              'metrô',
          ],
          bandera: '',
          noclick:true,
          currentText:0,
          correctoDrop:Array(10).fill(false),
          bien1:Array(10).fill(false),
          bien2:Array(10).fill(false),
          mal1:Array(10).fill(false),
          mal2:Array(10).fill(false),
          contadorGlobal:0,
          correcto:Array(2).fill(false),
    }
  },
  methods: {
    reproducirAudio(audioPosition){
      this.$refs.audioPlayer.playAudio(audioPosition)
    }, 
    next () {
      this.onboarding = this.onboarding + 1 === this.length
        ? 0
        : this.onboarding + 1
    },
    prev () {
      this.onboarding = this.onboarding - 1 < 0
        ? this.length - 1
        : this.onboarding - 1
    },
    validando(arrayDrop, arrayRespuestas,idx,arrayBien,arrayMal){
      if (arrayDrop.length-1 !=-1) {        
      this.reproducirAudio(arrayDrop[arrayDrop.length-1].audio)
      }
      var contador = 0
      console.log(arrayDrop)
      for (let i = 0; i < arrayDrop.length; i++) {
        for (let j = 0; j < arrayRespuestas.length; j++) {
            if(arrayDrop[i].palabra==arrayRespuestas[j]){
              contador++
              this.$set(arrayBien,arrayDrop.length-1,true)
            } 
        }              
      }
      //alert('Array'+idx+': '+arrayBien)
      //console.log('arrayRespuestas '+idx+' - tamaño:'+arrayRespuestas.length)
      if(contador === arrayRespuestas.length){
        this.$set(this.correcto,idx,true)
        console.log('drop '+idx+': correcto')
        this.validacionGlobal()
      }
    },
    validacionGlobal(){
      this.contadorGlobal=0
      for (let i = 0; i < this.correcto.length; i++) {
        if (this.correcto[i]===true) {
          this.contadorGlobal++
          console.log('contadorGlobal: '+this.contadorGlobal)
        }      
      }    
      if (this.contadorGlobal==2) {
        setTimeout(() => {
          this.modal = true
          this.modalResult="bien"
          this.reiniciar()
          this.$store.commit('nextShow', true)
        }, 2000);
        
      }
      if(this.vectoroObj.length === 0 && (this.contadorGlobal < this.correcto.length)){
        this.modal = true        
        this.modalResult="mal"
      }
    },
    reiniciar(){
      this.vector= [            
              'guru', 
              'sul', 
              'farol', 
              'calma', 
              'prato', 
              'avô', 
              'dó', 
              'forró', 
              'metrô',
          ]
      this.vectoroObj= [  
              {palabra:'guru', audio: 0}, 
              {palabra:'sul', audio: 1}, 
              {palabra:'farol', audio: 2}, 
              {palabra:'calma', audio: 3}, 
              {palabra:'prato', audio: 4}, 
              {palabra:'avô', audio: 5}, 
              {palabra:'dó', audio: 6}, 
              {palabra:'forró', audio: 7}, 
              {palabra:'metrô', audio: 8},
          ],
      this.vectoroObj = this.vectoroObj.sort(function() {return Math.random() - 0.5})
      this.VectorUno=[]
      this.VectorDos=[]
      this.VectorTres=[]
      this.contadorGlobal=0
    },
    avanzar(){
      this.$store.commit('nextShow', true)
    }
  },
  created(){
    this.vectoroObj = this.vectoroObj.sort(function() {return Math.random() - 0.5})
  },
  watch: {
    currentText(val){
      if (val >= this.dialogos.length -1) {
        this.noclick=false
      }      
    },
     
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';

.titulo{
  font-size: 17px;
}


.letraa{
 width: 100%; 
    /* height: 13%; */
 
    /* position: fixed; */
    /* display: -webkit-box; */
    display: -ms-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    /* padding: 18px; */
    text-align: center;
}
.draggable_contenido{

  p{
    border-bottom: 3px solid #D37A1C;
  }
  width: 43%;
  height: 35vh;
   border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
 
   border-top: 3px solid #D37A1C;
   border-left: 3px solid #D37A1C;
   border-bottom: 3px solid #D37A1C;
   border-right: 1px solid #D37A1C;
   ul{
    list-style: none;
    
  }
}
.draggable_contenido_medio{

  p{
    border-bottom: 3px solid #D37A1C;
  }
  width: 33%;
  height: 35vh; 
   border-top: 3px solid #D37A1C;
   border-left: 1px solid #D37A1C;
   border-bottom: 3px solid #D37A1C;
   border-right: 1px solid #D37A1C;
   ul{
    list-style: none;
    
  }
}
.elemento {
  background: #0067AD;
  color: white;
  padding: 7px;
  border-radius: 10px;
  font-size: 12px;
  margin-bottom: 4px;
}

.elementointerno {

  font-size: 1rem;
  margin: 7px;

}
.elemento_amarillo{
  width: 100%;
  height: 76%;
  padding: 2px;
    /* margin: 4px; */
   
    align-items: center;
    text-align: center;
  
}

.draggable_contenidos{
  p{
    border-bottom: 3px solid #D37A1C;
    
  }
    width: 44%;
    height: 35vh;
    border-bottom-right-radius: 15px;
    border-top-right-radius: 15px;  
    border-top: 3px solid #D37A1C;
    border-right: 3px solid #D37A1C;
    border-bottom: 3px solid #D37A1C;
    border-left: 1px solid #D37A1C;
   ul{
    list-style: none;
  }
}

.grag_inferior{
  
  border-radius: 10px;
 
  ul{
    list-style: none;
     display: inline-flex;
  }
}
.btn-drag {

    display: flex;
    justify-content: center;
}
p.title-table{
  font-size: .9rem ;
  margin-top: 10px;
  padding-bottom: 5px;
  
}
// .bien{
//     color:green;    
// }
// .mal{
//     color:red;    
// }
</style>